import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';

import type { PaymentMethodPixValue_charge$key } from './__generated__/PaymentMethodPixValue_charge.graphql.ts';

type PaymentMethodPixValueProps = {
  charge: PaymentMethodPixValue_charge$key;
};

const PaymentMethodPixValue = (
  props: PaymentMethodPixValueProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentMethodPixValue_charge$key>(
    graphql`
      fragment PaymentMethodPixValue_charge on Charge {
        company {
          nameFriendly
        }
        value
        paymentSubscriptionInstallment {
          value
        }
      }
    `,
    props.charge,
  );

  const value =
    charge.paymentSubscriptionInstallment?.value ?? (charge.value as number);

  return (
    <Typography variant='h5' fontWeight='bold' textAlign='center'>
      {t('Pay {{value}} to {{companyName}} via Pix', {
        value: convertToMoney(value),
        companyName: charge?.company?.nameFriendly,
      })}
    </Typography>
  );
};

export default PaymentMethodPixValue;
